export interface KngCountOfItemCardData {
  state: KngCountOfItemCardDataState | undefined;
}
export interface KngCountOfItemCardDataState {
  cssClass: string;
  cardType: CardTypes;
  title: {
    label: string;
  };
  image: {
    label: string;
    url: string;
    alt: string;
  };
  unit: Array<UnitObj>;
  error?:string;
  loading?:boolean;
  comingSoon?:boolean;
}
export interface UnitObj {
  label: string;
  description: {
    label: string;
  };
  amount: string;
  currency?: string;
  connectedCount?: ConnectedCount;
  tooltip?: string;
}
export interface ConnectedCount {
  label: string;
  icon: {
    url: string;
    alt: string;
  };
  value: string;
}

export type CardTypes = 'unitCard' | 'stackedCard' | 'amountCard' | 'connectedCountCard';

export enum CountOfItemsCardTypes {
  unitCard = 'unitCard',
  stackedCard = 'stackedCard',
  amountCard = 'amountCard',
  connectedCountCard = 'connectedCountCard'
}
